import { Types } from "../constants/index.js";
import DeviceDataSource from "./DeviceDataSource.js";
import DeviceGroupDataSource from "./DeviceGroupDataSource.js";
import DeviceTypeDataSource from "./DeviceTypeDataSource.js";
import FirmwareApplicationDataSource from "./FirmwareApplicationDataSource.js";
import FirmwareComponentDataSource from "./FirmwareComponentDataSource.js";
import FirmwareReleaseDataSource from "./FirmwareReleaseDataSource.js";
const install = molten => {
  molten.addPlugin('DataSource', {
    type: Types.device,
    dataSource: new DeviceDataSource()
  });
  molten.addPlugin('DataSource', {
    type: Types.deviceGroup,
    dataSource: new DeviceGroupDataSource()
  });
  molten.addPlugin('DataSource', {
    type: Types.deviceType,
    dataSource: new DeviceTypeDataSource()
  });
  molten.addPlugin('DataSource', {
    type: Types.firmwareApplication,
    dataSource: new FirmwareApplicationDataSource()
  });
  molten.addPlugin('DataSource', {
    type: Types.firmwareComponent,
    dataSource: new FirmwareComponentDataSource()
  });
  molten.addPlugin('DataSource', {
    type: Types.firmwareRelease,
    dataSource: new FirmwareReleaseDataSource()
  });
};
export { install };
export default {
  install
};